import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TVTechnology: Site = {
  id: 'tvtechnology',
  logo: 'svg/tvtech.svg',
  label: 'TV Technology',
  analyticsName: 'tvtechnology',
  hostname: 'tvtechnology.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
